// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pointer {
    cursor: pointer;
}

.default {
    cursor: default;
}

.main_btn_wrap {
    margin-top: 100px;
    text-align: center;
    display: flex;
    justify-content: center;
}

.main_btn_wrap>div {
    margin-bottom: 10px;
}

.main_btn_wrap>div button {
    width: 100px;
    height: 100px;
}

.ds_n {
    display: none !important;
}

.fw-n {
    font-weight: normal;
}

.content {
    padding-top: 5rem;
    /* margin-top: 3.5rem; */
}

@media (min-width: 1280px) {
    .content .content-wrap {
        /* padding-top: 5rem; */
    }
}

@media (max-width: 1279px) {}

@media (max-width: 768px) {
    .content {
        padding-top: .5rem;
        margin: 3.5rem 0rem 0rem;
    }

    .contents_wrap {
        height: auto;
    }
}

/* left 시작 */
@media (min-width: 1280px) {
    .side-nav {
        width: 12rem;
        height: 100dvh;
        padding: 5rem .75rem 4rem;
    }
}

@media (min-width: 768px) {
    .side-nav {
        margin: 0;
        padding-top: 4.5rem;
        overflow-x: visible;
    }
}

.side-nav>ul>li>.side-menu.side-menu--active .side-menu__icon {
    color: #fff;
}

.side-nav>ul>li>.side-menu.side-menu--active .side-menu__title {
    font-weight: bold;
    color: #fff;
}

.side-nav>ul>li .depth-2 .side-menu--active .side-menu__title {
    font-weight: bold;
}

.side-nav>ul>li>.side-menu.side-menu--active:before {
    background-color: rgb(var(--color-primary) / var(--tw-bg-opacity));
}

@media (min-width: 1280px) {
    .side-nav ul li .depth-2 {
        margin-left: 1.25rem;
        margin-bottom: .25rem;
        padding: .125rem 0;
    }
}

@media (max-width: 1280px) {
    .side-nav {
        width: 105px;
    }
}

@media (max-width: 767px) {
    .side-nav {
        display: none;
    }
}

/* @media (min-width: 1280px){
    .side-nav {
        height: 100vh;
        
    }
} */
/* left 끝 */

/* loading 시작 */
.pay_loading_wrap {
    width: 100vw;
    height: 100vh;
    background: rgb(0 0 0 / 65%);

    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 60;
}

.pay_loading_wrap .pay_loading {
    border-radius: 110px;
    overflow: hidden;

    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

}

/* loading 끝 */

/* 공지사항 시작 */
.notice .tabulator {
    height: calc(100vh - 18rem);
}

.notice .tabulator .tabulator-tableHolder {
    height: auto !important;
    min-height: auto !important;
    max-height: calc(100% - 8rem) !important;
}

.inner-wrap {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.content-container {
    width: 100%;
    /* max-width: 33.75rem; */
    margin: auto;
}

.main-title-wrap {
    /* padding-top: .75rem; */
    border-bottom: .0625rem solid #d1d5d9;
}

.main-title-wrap .title {
    display: inline-block;
    position: relative;
    padding: 0 1rem;
    font-size: .875rem;
    font-weight: bold;
    line-height: 3.25rem;
}

.main-title-wrap .title:before {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    bottom: -.0625rem;
    height: .1875rem;
    background: #064e3b;
    border-top-left-radius: .1875rem;
    border-top-right-radius: .1875rem;
}

.main-title-wrap .btn-wrap {
    position: absolute;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
    padding-top: .75rem;
}

.main-title-wrap .btn-wrap button {
    width: 2.25rem;
    height: 2.25rem;
}

.main-title-wrap .btn-wrap button+button {
    margin-left: .25rem;
}

.main-title-wrap .btn-wrap button svg {
    width: auto;
    height: 1.75rem;
    margin: 0 auto;
}

@media (max-width: 768px) {
    .notice .tabulator {
        height: auto;
    }
}

/* 공지사항 끝 */

.tabulator .tabulator-footer .tabulator-paginator {
    justify-content: center;
    margin: 0;
    text-align: center !important;
}

/*-------------------- Modal --------------------*/
/* .scroll_lock { overflow:hidden; } */

.modal {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    transition: visibility 0s ease 0.2s, opacity .2s 0s;
    width: auto;
    height: auto;
    margin: 0;
    background: rgb(0 0 0 / 65%);
    overflow-x: hidden;
    overflow-y: auto;
    visibility: visible;
    opacity: 1;
    z-index: 100000;
}

.modal.alert_modal .modal-dialog {
    top: 50%;
    transform: translateY(-50%);
}

.modal .modal-dialog,
.modal#payment-modal .modal-dialog {
    position: relative;
    top: 50%;
    /* transform: none; */
    transform: translateY(-50%);
    transition: top .3s ease;
    width: 95%;
    max-width: 40rem;
    margin: auto;
    padding: .5rem 1.5rem;
    border-radius: .5rem;
    background: #fff;
    overflow: hidden;
}

.board_modal .modal-dialog {
    top: 6%;
    max-width: 42rem;
}

.modal .modal-dialog .modal-content {
    margin: 0;
    max-height: none;
    box-shadow: none;
}

.modal .modal-dialog .modal-header {
    position: relative;
    width: auto;
    /* padding: 1rem 0; */
    padding: 0;
}

.modal .modal-dialog .modal-header h2 {
    display: block;
    font-weight: bold;
}

.modal .modal-dialog .modal-header button {
    float: none;
    padding: 0;
}

.modal .modal-dialog .modal-header button span,
.modal .modal-dialog .modal-header button svg {
    width: 1.625rem;
    height: 1.625rem;
}

.modal .modal-dialog .modal-header .close_btn_sty svg {
    transform: rotate(.37turn);
}

.modal .modal-dialog .modal-header svg {
    transform: rotate(.37turn);
}

.modal .modal-dialog .modal-body {
    overflow: auto;
    margin: 0;
    padding: 1.5rem 0;
}

.modal .modal-dialog .modal-body label {
    margin-bottom: .375rem;
    font-size: .8125rem;
    font-weight: bold;
}

.modal .modal-dialog .modal-body input:read-only,
.modal .modal-dialog .modal-body textarea:read-only {
    border: none;
    box-shadow: none;
    color: #8292a3;
}

.modal .modal-dialog .modal-footer {
    display: flex;
    justify-content: center;
    padding: 1rem 0 .5rem;
    text-align: center;
}

.modal .modal-dialog .modal-footer button {
    width: 50%;
    max-width: 8rem;
}

.modal .modal-dialog .modal-footer button+button {
    margin-left: .75rem;
}

.show_modal {
    visibility: visible;
    opacity: 1;
}

.show_modal .modal-dialog,
.show_modal#payment-modal .modal-dialog {
    /* top: 0; */
}

/* alert modal, confirm modal START */
.modal .modal-footer .btn_ok {
    color: #fff;
    background-color: #064e3b;
}

/* alert modal, confirm modal END */

/* top */
.top-bar-boxed {
    height: auto;
    padding: 0.375rem 1.25rem;
    /* padding: 0.375rem 1.375rem; */
    background: #1a120b;
}

.top-bar-boxed:before {
    content: none;
}

.top-bar-boxed:after {
    content: none;
}

.top-bar-boxed .logo img {
    width: auto;
    max-width: none;
    height: 2.5rem;
}

.dropdown-user-info {
    z-index: 9999;
    inset: 0 auto auto 0;
    /* visibility: hidden; */
    position: absolute;
    /* opacity: 0; */
    width: 224px;
    margin: 0;
    transform: translate(-192px, 53px);
}

.notification_list {
    z-index: 9999;
    inset: 0 auto auto 0;
    visibility: hidden;
    position: absolute;
    opacity: 1;
    width: 224px;
    margin: 0;
    transform: translate(-166px, 53px);
}

.notification_list .show>.dropdown-content {
    margin-top: .25rem;
}

.notification_list .dropdown-content {
    transition: margin-top .2s;
    box-shadow: 0 3px 10px #00000017;
    position: relative;
    width: 100%;
    border-radius: .375rem;
    padding: .5rem;
}

.dropdown-user-info .show>.dropdown-content {
    margin-top: .25rem;
}

.dropdown-user-info .dropdown-content {
    transition: margin-top .2s;
    box-shadow: 0 3px 10px #00000017;
    position: relative;
    width: 100%;
    border-radius: .375rem;
    padding: .5rem;
}

.dropdown-user-info .dropdown-content .dropdown-item {
    display: flex;
    align-items: center;
    border-radius: .375rem;
    padding: .5rem;
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
    transition-duration: 300ms;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

.notification_list .dropdown-content .dropdown-item {
    display: flex;
    align-items: center;
    border-radius: .375rem;
    padding: .5rem;
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
    transition-duration: 300ms;
}

.dropdown-user-info.show {
    visibility: visible;
    opacity: 1;
}

@media(max-width:1278px) {
    .top-bar-boxed {
        display: none;
    }

    /* dropdown */
    .dropdown-user-info {
        transform: translate(-174px, 50px);
    }
}

@media (max-width: 776px) {
    .dropdown-user-info {
        transform: translate(-171px, 50px);
    }
}

@media(max-width:770px) {
    .dropdown_user {
        display: none;
    }
}

/* @media(max-width:639px) {
    .datepicker {
        width: calc(100% - 58px - 0.25rem);
        margin-bottom: 0.5rem;
        width: 80%;
    }
} */

/* mobile left START */
.mobile-menu {
    display: none;
    margin: 0;

    top: 0;
    left: 0;
}

.mobile-menu .menu {
    padding-left: .5rem;
    padding-right: .5rem;
    font-size: .9rem;
}

.mobile-menu .menu.on {
    font-weight: bold;
    color: #cce568;

    position: relative;
}

.mobile-menu .menu.on::after {
    content: "";
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background-color: #cce568;

    position: absolute;
    top: 8px;
    right: 4px;
}

.mobile-menu .mobile-menu-bar {
    height: 57px;
}

.mobile-menu .mobile-menu-bar .mobile-menu-wrap {
    margin-left: 2vw;
    position: relative;
    display: flex;
}

.mobile-menu .mobile-menu-bar .mobile-menu-toggler {
    display: inline-block;
    width: 2.5rem;
    height: 2.5rem;
    z-index: 10;

    position: relative;
}

.mobile-menu .mobile-menu-bar .mobile-menu-toggler svg {
    width: 0.875rem;
    height: 0.125rem;
    background: #acd560;
    overflow: hidden;
    opacity: 1;

    position: absolute;
    top: 50%;
    right: 0.5625rem;
    transition: .4s cubic-bezier(.5, .1, 0, 1.2);
    transform: translateY(-50%);
}

.mobile-menu-toggler:after,
.mobile-menu-toggler:before {
    content: "";
    display: block;
    height: 0.125rem;
    margin-top: 0.625rem;
    background: #fff;

    position: absolute;
    right: 0.5625rem;
    transition: .4s cubic-bezier(.5, .1, 0, 1.2);
}

.mobile-menu .mobile-menu-bar .mobile-menu-toggler:before {
    width: 1.125rem;

    top: 0;
}

.mobile-menu .mobile-menu-bar .mobile-menu-toggler:after {
    width: 1.375rem;

    top: 1.125rem;
}

.mobile-menu .mobile-menu-bar .mobile-menu-toggler.mobile-menu--active svg {
    width: 0;
    opacity: 0;
}

.mobile-menu .mobile-menu-bar .mobile-menu-toggler.mobile-menu--active:before {
    width: 1.5rem;

    transform: translateX(0.0625rem) translateY(0.5625rem) rotate(-45deg);
}

.mobile-menu .mobile-menu-bar .mobile-menu-toggler.mobile-menu--active:after {
    width: 1.5rem;

    transform: translateX(0.0625rem) translateY(-0.5625rem) rotate(45deg);
}

@media (max-width: 1278px) {
    .mobile-menu {
        display: block;
    }
}

/* mobile left END */

/* 페이징 START */
.tabulator .tabulator-footer .tabulator-paginator .tabulator-page.active {
    color: #fff;
    background-color: rgb(var(--color-primary) / var(--tw-bg-opacity));
}

.tabulator .tabulator-footer .tabulator-paginator .tabulator-page.active:hover {
    color: #fff;
    background-color: rgb(var(--color-primary) / var(--tw-bg-opacity));
}

/* 페이징 END */

.tabulator_summary_wrap {
    display: flex;
    column-gap: 0.875rem;
    width: 100%;
    align-items: flex-start;
    /* padding: 1rem 0 1.5rem; */
    /* margin: 1rem 0; */
    margin: 0 0 .5rem;
    /* background: #f1f5f9;
    border-radius: 0.375rem; */

    position: relative;
}

.payment .tabulator_summary_wrap {
    flex-wrap: wrap;
}

.tabulator_summary_wrap .input_wrap {
    display: flex;
    flex-basis: 13.75rem;
    flex-grow: 0;
    align-items: center;
    column-gap: 1rem;
    padding: 0.5rem 1rem;
    border-radius: 0.375rem;
    background: #f1f5f9;
}

.tabulator_summary_wrap .input_wrap label {
    flex-shrink: 0;
    font-size: .8125rem;
}

.tabulator_summary_wrap .input_wrap input {
    width: 100%;
    padding: 0;
    font-size: 1rem;
    font-weight: bold;
    text-align: right;
    border: none;
    box-shadow: none;
    background-color: transparent;
}

.tabulator_summary_wrap .btn_more {
    margin-left: 0.25rem;
    outline: none;
}

.tabulator_summary_wrap .btn_more svg {
    width: 1.25rem;
    height: 1.25rem;
    /* margin: 0.125rem; */
}

.tabulator_summary_wrap .btn_more.short svg {
    transform: rotate(180deg);
}

@media (max-width: 1500px) {
    .payment .tabulator_summary_wrap {
        flex-direction: column;
    }

    .tabulator_summary_wrap {
        gap: 0.25rem;
    }

    .tabulator_summary_wrap .input_wrap {
        flex-basis: unset;
    }

    .payment .tabulator_summary_wrap .input_wrap {
        width: 100%;
    }

}

@media (max-width: 768px) {
    .tabulator_summary_wrap {
        flex-direction: column;
    }

    .tabulator_summary_wrap .input_wrap {
        width: 100%;
        gap: 0;
        /* justify-content: space-between; */
    }

    .tabulator_summary_wrap input {
        text-align: right;
    }
}

.tabulator_sorting_wrap {
    width: 100%;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    height: 36px;
}

.tabulator_sorting_wrap .excel_download {
    display: flex;
    flex-wrap: wrap;
    gap: .375rem .625rem;
}

.tabulator_sorting_wrap .excel_download button {
    border: none;
    background: #434242;
    font-size: .8125rem;
    color: #fff;
}

.tabulator_sorting_wrap .excel_download button:hover {
    background: #434242;
}

.tabulator_sorting_wrap .excel_download button svg {
    width: 1.0625rem;
    height: 1.0625rem;
    margin-right: .375rem;
}

.tabulator_sorting_wrap .excel_download .btn-warning {
    background: #f59e0b;
}

.tabulator_sorting_wrap .excel_download .btn-warning:hover {
    background: #f58c0b;
}

.tabulator_sorting_wrap .rows_per_page {
    flex-shrink: 0;
}

.tabulator_sorting_wrap .rows_per_page select {
    height: 2.25rem;
    font-size: .8125rem;
    cursor: pointer;
}

.tabulator_sorting_wrap .excel_download .tabulator_total_cnt_wrap {
    justify-content: flex-start;
    position: relative;
    right: auto;
    margin: 0;
    padding: 0;
}

.tabulator_sorting_wrap .excel_download .tabulator_total_cnt_wrap input {
    width: auto;
    padding: 0;
    border-radius: 0;
    background: none;
    line-height: 2.25rem;
    text-align: left;
}

.tabulator_total_cnt_wrap {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: .5rem 0;
}

.tabulator_total_cnt_wrap input {
    width: 100%;
    border-radius: .375rem;
    border: none;
    background: #dce6ef;
    font-size: .875rem;
    font-weight: bold;
    text-align: center;
}

.tabulator_total_cnt_wrap input:focus {
    box-shadow: none;
    border: none;
    outline: none;
}

.tabulator_sorting_wrap .excel_download .tabulator_total_cnt_wrap {
    justify-content: flex-start;
    position: relative;
    right: auto;
    margin: 0;
    padding: 0;
}

.tabulator_sorting_wrap .excel_download .tabulator_total_cnt_wrap input {
    width: auto;
    padding: 0;
    border-radius: 0;
    background: none;
    line-height: 2.25rem;
    text-align: left;
}







.form_filter {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    flex-wrap: nowrap;
    /* padding: 1rem 1.25rem 1.25rem; */
    padding: 0.5rem 0.5rem;
    border-radius: 0.75rem;
    background: #fff;
    border: 0.125rem solid #064e3b;

    position: relative;
}

/* .form_filter.outer {
    margin-top: 1.25rem;
} */


.form_filter {
    gap: 4rem;
    align-items: flex-start;
}

.form_filter .form_filter_inner {
    width: calc(100% - 5rem);
    display: flex;
    /* align-items: center; */
    gap: 1rem;
}

.form_filter label {
    display: inline-block;
    font-size: .8125rem;
    font-weight: bold;
    flex-basis: 10%;
    line-height: 2.375rem;
}

.form_filter .form_filter_inner>div {
    display: flex;
    flex-wrap: wrap;
    width: 90%;
    gap: 0.25rem;
}

.form_filter .form_filter_inner>div>div {
    gap: 0.25rem;
    flex-grow: 1;
}

.form_filter .form_filter_inner>div>div>button {
    width: auto;
    flex-grow: 1;
}

.form_filter .form_filter_inner>div input {
    width: 50%;
    flex-grow: 1;
}

/* .paylist .form_filter .form_filter_inner > div input {
    margin-bottom: 0.25rem;
} */
/* .paylist .form_filter .form_filter_inner > div button {
    margin-left: 0.25rem;
} */
.form_filter .searchPayBtn {
    /* width: 5rem; */
}

.paylist .more_wrap {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translate(-50%, 60%);
    z-index: 70;
}

.paylist .btn_more1 {
    display: flex;
    align-items: center;
    justify-content: center;
    column-gap: 0.25rem;
    padding: 0.25rem 1rem;
    border-radius: 1.75rem;
    box-shadow: 0 0.0625rem 0.25rem rgb(0 0 0 / 20%);
    background: #fff;
    color: #074f3c;
}

.paylist .btn_more1 span {
    font-size: .75rem;
    font-weight: 500;
}

.paylist .btn_more1 svg {
    width: 1rem;
    height: 1rem;
    transform: rotate(180deg);
}

.paylist .btn_more1.short svg {
    transform: rotate(0deg);
}

@media (max-width: 1348px) {
    .payment .form_filter {
        gap: 1rem;
    }

    .payment .datepicker {
        margin-bottom: 0;
    }
}

@media (max-width: 823px) {
    .form_filter .form_filter_inner>div input {
        width: 40%;
    }
}

@media (max-width: 768px) {
    .form_filter {
        flex-direction: column;
        align-items: flex-start;
        gap: 1rem;
    }

    .form_filter .form_filter_inner {
        width: 100%;
        align-items: flex-start;
        gap: 0.25rem;
    }

    .form_filter .form_filter_inner>div {
        width: 100%;
        flex-direction: column;
        row-gap: 0.25rem;
    }

    .form_filter label {
        flex-basis: 30%;
        line-height: 2.375rem;
    }

    .form_filter .form_filter_inner>div input {
        width: 100%;
    }

    .form_filter .form_filter_inner input {
        width: 100%;
    }

    .form_filter>.searchPayBtn {
        width: 100%;
    }

    .form_filter .form_filter_inner>div button {
        width: calc((100% - 0.25rem) / 3);
    }
}

@media(max-width: 508px) {
    .form_filter label {
        flex-basis: 20%;
    }

    .form_filter .form_filter_inner>div>div>button {
        padding: 0.5rem 0.2rem;
    }
}


/* notice START */
.notice .form_filter {
    gap: 0.5rem;
    align-items: center;
}

.notice .input_item {
    max-width: 300px;
    flex-grow: 1;
}

.notice .form_filter label {
    display: block;
    margin-bottom: 0.25rem;
    font-weight: bold;
}

@media(min-width:640px) {
    .tabulator_summary_wrap .tabulator_total_cnt_wrap {
        width: 100%;
    }
}

@media (min-width: 768px) {
    .notice .form_filter {
        padding: 1rem 0 0;
        border-color: transparent;
        background-color: transparent;
        justify-content: flex-start;
    }

    .notice .form_filter label {
        display: none;
    }

    .tabulator_total_cnt_wrap {
        margin: .1875rem 0 0;
        padding-left: 2rem;
    }

    .tabulator_total_cnt_wrap input {
        font-size: .9375rem
    }

    .tabulator_total_cnt_wrap input:focus {}

    .tabulator_summary_wrap .tabulator_total_cnt_wrap {
        margin-top: .5rem;
        padding: 0;
    }
}

@media(min-width:1280px) {
    .tabulator_total_cnt_wrap {
        position: absolute;
        right: 1.5rem;
        margin: 0;
        padding: 0;
    }

    .tabulator_total_cnt_wrap input {
        padding: 0;
        border-radius: 0;
        background: none;
        font-size: 1rem;
        text-align: right;
    }

    .tabulator_total_cnt_wrap input:focus {}

    .tabulator_summary_wrap .tabulator_total_cnt_wrap {
        right: 0;
        width: auto;
    }

    .tabulator_sorting_wrap .excel_download .tabulator_total_cnt_wrap {}

    .tabulator_sorting_wrap .excel_download .tabulator_total_cnt_wrap input {}
}

@media (max-width: 768px) {

    /* .notice .form_filter .input_item {
        width: auto;
    } */
    .notice .input_item {
        display: flex;
        max-width: 100%;
        width: 100%;
        gap: 0.5rem
    }

    .notice .input_item label {
        flex-shrink: 0;
    }

    .notice .form_filter button {
        flex-shrink: 0;
    }
}

/* notice END */


/*------------------------ modal receipt style ------------------------*/

.modal .modal-dialog .type-receipt {}

.modal .modal-dialog .type-receipt .modal-header {
    z-index: 2;
}

/* .modal .modal-dialog .type-receipt .modal-header::after,
.modal .modal-dialog .type-receipt .modal-footer::after {
    content: "";
    position: absolute;
    left: -.4375rem;
    width: .875rem;
    height: .875rem;
    border-radius: 50%;
    box-shadow: 1rem 0 #fff, 2.5rem 0 #fff, 4rem 0 #fff, 5.5rem 0 #fff, 7rem 0 #fff, 8.5rem 0 #fff, 10rem 0 #fff, 11.5rem 0 #fff, 13rem 0 #fff, 14.5rem 0 #fff, 16rem 0 #fff, 17.5rem 0 #fff, 19rem 0 #fff, 20.5rem 0 #fff, 22rem 0 #fff, 23.5rem 0 #fff, 25rem 0 #fff, 26.5rem 0 #fff, 28rem 0 #fff, 29.5rem 0 #fff;
    background: transparent;
} */

/* .modal .modal-dialog .type-receipt .modal-header::after {
    bottom: -.4375rem;
} */

.modal .modal-dialog .type-receipt .modal-body {
    position: relative;
    padding: 0;
}

.modal .modal-dialog .type-receipt .modal-body::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    /* border-left: .0625rem solid rgba(0, 0, 0, .08); */
    /* border-right: .0625rem solid rgba(0, 0, 0, .08); */
    pointer-events: none;
}

.modal .modal-dialog .type-receipt .box-sales {
    /* max-height: calc(100vh - 17.5rem); */
    padding: 2rem 1rem;
    /* background: #eee; */
    overflow-y: auto;
}

.modal .modal-dialog .type-receipt .box-sales #header h1 {
    /* filter: brightness(.75) grayscale(1); */
}

.modal .modal-dialog .type-receipt .box-sales #header h2 {
    font-size: 1.0625rem;
    color: #424242;
}

.modal .modal-dialog .type-receipt .box-sales .list-info-box {}

.modal .modal-dialog .type-receipt .box-sales .box-gap {
    margin: 0;
}

.modal .modal-dialog .type-receipt .box-sales .box-gap+.box-gap {
    margin-top: 1rem;
}

.modal .modal-dialog .type-receipt .box-sales .gap {}

.modal .modal-dialog .type-receipt .box-sales .gap .tt {
    /* margin-bottom: .25rem; */
    /* background: #d7d7d7; */
    position: relative;
    z-index: 1;
}

.modal .modal-dialog .type-receipt .box-sales .gap .tt::after {
    content: '';
    display: block;
    clear: both;
    background: #696a6b;
    height: 1px;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
}

.modal .modal-dialog .type-receipt .box-sales .gap .tt h3 {
    color: #fff;
    font-size: 14px;
    background: #898a8c;
    border-radius: 5px 5px 0 0;
    padding: 0 15px;
    display: inline-block;
    height: 27px;
    line-height: 27px;
    position: relative;
    z-index: 2;
    font-weight: normal;
}

.modal .modal-dialog .type-receipt .box-sales .gap li {
    display: flex;
    flex-wrap: wrap;
    /* column-gap: .875rem; */
    border: none;
    border-bottom: .0625rem solid #ddd;
}

.modal .modal-dialog .type-receipt .box-sales .gap li+li {}

.modal .modal-dialog .type-receipt .box-sales .gap li::after {
    display: none;
}

.modal .modal-dialog .type-receipt .box-sales .gap li .inner {
    float: initial;
    display: inline-flex;
    flex-wrap: wrap;
    flex-basis: calc(50% - .4375rem);
    flex-grow: 1;
    justify-content: space-between;
    width: auto;
    /* padding: .375rem 0; */
}

.modal .modal-dialog .type-receipt .box-sales .gap li .inner::after {
    display: none;
}

.modal .modal-dialog .type-receipt .box-sales .gap li .inner .left-text,
.modal .modal-dialog .type-receipt .box-sales .gap li .inner .right-text {
    float: initial;
    width: auto;
    padding: 0;
    /* font-size: .7rem; */
    font-size: 9.5px;
    color: #424242;
}

.modal .modal-dialog .type-receipt .box-sales .gap li .inner .left-text {
    width: 32%;
    background: #f9f9f9;
    /* padding: 5px 12px; */
    padding: 5px 0 5px 5px;
    /* font-size: .7rem; */
    font-size: 9.5px;
    display: flex;
    align-items: center;
}

.modal .modal-dialog .type-receipt .box-sales .gap li .inner .right-text {
    word-break: break-word;
    width: 68%;
    /* padding: 5px 12px; */
    padding: 5px 0 5px 5px;
    color: #646464;
    display: flex;
    align-items: center;
}

.modal .modal-dialog .type-receipt .box-sales .type-2 {
    display: flex;
    column-gap: 1.25rem;
}

.modal .modal-dialog .type-receipt .box-sales .type-2 .gap {
    width: auto;
    flex-basis: calc(50% - .625rem);
    flex-grow: 1;
    flex-shrink: 0;
}

.modal .modal-dialog .type-receipt .box-sales .list-info-box {}

.modal .modal-dialog .type-receipt .box-sales .infoFooter {
    margin: 1.25rem 0 0;
    /* font-size: .6875rem; */
    font-size: 10px;
    line-height: 1.5;
    color: #424242;
}

.modal .modal-dialog .type-receipt .box-sales .box-btn {
    margin: 1.25rem 0 0;
}

.modal .modal-dialog .type-receipt .box-sales .box-btn button {
    height: 2.375rem;
    margin: 0 0 0 -.1875rem;
    border: none;
    background: #424242;
    font-family: inherit;
    font-size: .9375rem;
    font-weight: bold;
    line-height: 2.375rem;
}

.modal .modal-dialog .type-receipt .modal-footer {
    /* position: relative; */
    z-index: 1;
}

.modal .modal-dialog .type-receipt .modal-footer::after {
    top: -.4375rem;
}


.list-info-box .gap ul li .left-text,
.list-info-box .gap ul li .right-text {
    float: left;
    color: #2d2e2f;
    /* font-size: 14px;
    padding: 7px 0; */
}

.list-info-box .gap ul li .left-text {
    width: 100px;
    font-weight: bold;
}

.box-sales #header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 1.25rem;
    padding: 0;
    border: none;
}

.box-sales #header h1 img {
    height: 2rem;
}

.tabulator_summary_wrap .d_none {
    display: none;
}

/* loading 끝 */

@media (min-width: 1280px) {
    .side-nav .side-menu .side-menu__icon svg {
        width: 1.25rem;
        height: 1.25rem;
    }
}

.mobile-menu .scrollable {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    top: 52px;
    transform: translateX(100%);
    width: 100%;
    height: calc(100% - 52px);
    margin: 0;
    background: #f1f5f9;
    overflow-y: auto;
}

.mobile-menu.mobile-menu--active .scrollable {
    transform: translateX(0);
}

.mobile-menu.mobile-menu--active .scrollable {
    margin-left: 0px;
}

.mobile-menu .menu_wrap {
    padding: 2rem 1.25rem 1.5rem;
}

.mobile-menu .user_info_wrap {
    margin-bottom: 1.75rem;
}

.mobile-menu .user_detail {
    display: flex;
    align-items: center;
    gap: .375rem;
    margin-bottom: .5rem;
}

.mobile-menu .user_detail .user_authority {
    background: #fc8f94;
}

.mobile-menu .user_detail .user_organization {
    background: #9da2f4;
}

.mobile-menu .user_detail span {
    display: inline-block;
    padding: .0625rem .5rem 0;
    border-radius: .125rem;
    background: #a6bacb;
    font-size: .75rem;
    line-height: 1.3125rem;
    letter-spacing: -.02rem;
    color: #fff;
}

.mobile-menu .user_greeting {
    display: flex;
    align-items: flex-end;
    flex-wrap: wrap;
}

.mobile-menu .user_greeting .user_name {
    font-size: 1.375rem;
    font-weight: bold;
}

.mobile-menu .user_greeting p {
    font-size: 1.125rem;
    line-height: 1.75rem;
    letter-spacing: -.02rem;
    color: #1e203b;
}

.mobile-menu .user_greeting p {
    font-size: 1.125rem;
    line-height: 1.75rem;
    letter-spacing: -.02rem;
    color: #1e203b;
}

.mobile-menu .separation_line {
    height: .625rem;
    margin: 1.5rem -1.25rem 1rem;
    border-top: .0625rem solid #cdd4dd;
    background: #dde4ed;
}

.mobile-menu ul {
    padding: 0;
}

.mobile-menu ul li {
    -webkit-tap-highlight-color: transparent;
}

.mobile-menu ul li {
    cursor: pointer;
    max-width: 1280px;
    margin-left: auto;
    margin-right: auto;
    /* width: 100%; */
}

.mobile-menu .menu {
    height: 4rem;
    padding: 0;
    color: #1e293b;
}

.mobile-menu .menu {
    height: 50px;
    display: flex;
    align-items: center;
    padding-left: 1.5rem;
    padding-right: 1.5rem;
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity));
}

.mobile-menu ul li ul {
    margin: 0;
    padding: 0 0 1rem 1.5rem;
    background: none;
}

.mobile-menu ul li ul {
    margin-top: 0.25rem;
    margin-bottom: 0.25rem;
    border-radius: 0.5rem;
}

.mobile-menu ul li ul li {
    border: none;
}

.mobile-menu ul li {
    -webkit-tap-highlight-color: transparent;
}

.mobile-menu ul li {
    cursor: pointer;
    max-width: 1280px;
    margin-left: auto;
    margin-right: auto;
    /* width: 100%; */
}

.mobile-menu ul li ul .menu {
    height: 2.625rem;
    padding: 0;
}

.mobile-menu .menu {
    height: 4rem;
    padding: 0;
    color: #1e293b;
}

.mobile-menu .menu {
    display: flex;
    align-items: center;
    --tw-text-opacity: 1;
}

.mobile-menu ul li ul .menu .menu__title {
    position: relative;
    font-size: .9375rem;
    letter-spacing: -.02rem;
}

.mobile-menu .menu .menu__title {
    display: flex;
    align-items: center;
    width: 100%;
    margin-left: .75rem;
    font-size: 1.0625rem;
    font-weight: bold;
}

.mobile-menu .logout-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    border-top: .0625rem solid #d7d9da;
    background: rgba(255, 255, 255, .5);
}

.mobile-menu .logout-btn a {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 2.75rem;
    padding: 0 1rem;
    color: #64748b;
}

.mobile-menu .logout-btn svg {
    position: relative;
    top: -.125rem;
    margin-right: .375rem;
    width: 1.125rem;
    height: 1.125rem;
}

.mobile-menu ul li+li {
    border-top: .0625rem solid #d7d9da;
}

.mobile-menu .header_gnb {
    display: flex;
    column-gap: 2vw;
    margin-right: 1vw;
    padding: 0;
}

.mobile-menu .header_gnb li {
    border: none;
}

.mobile-menu .header_gnb li a {
    display: block;
    position: relative;
    padding: 0 .5rem;
    font-size: .9375rem;
    font-weight: 500;
    line-height: 2.5rem;
    color: rgba(255, 255, 255, .7);
}

.mobile-menu .menu .menu__title .menu__sub-icon {
    transform: none;
    position: relative;
    width: 1.625rem;
    height: 1.625rem;
}

.mobile-menu .menu .menu__title .menu__sub-icon {
    margin-left: auto;
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 100ms;
    transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
}

.mobile-menu .menu .menu__title .menu__sub-icon::before {
    width: 1rem;
    height: .125rem;
}

.mobile-menu .menu .menu__title .menu__sub-icon::after {
    width: .125rem;
    height: 1rem;
}

.mobile-menu .menu .menu__title .menu__sub-icon.rotate-180::after {
    display: none;
}

.mobile-menu .menu .menu__title .menu__sub-icon::before,
.mobile-menu .menu .menu__title .menu__sub-icon::after {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: #227862;
}

.mobile-menu ul li ul .menu .menu__title::before {
    content: "";
    position: relative;
    top: -.25rem;
    width: .5rem;
    height: .5rem;
    margin-right: .625rem;
    border-left: .0625rem solid #a7a9aa;
    border-bottom: .0625rem solid #a7a9aa;
}`, "",{"version":3,"sources":["webpack://./src/Pages/css/common.css"],"names":[],"mappings":"AAAA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,wBAAwB;AAC5B;;AAEA;IACI;QACI,uBAAuB;IAC3B;AACJ;;AAEA,4BAA4B;;AAE5B;IACI;QACI,kBAAkB;QAClB,wBAAwB;IAC5B;;IAEA;QACI,YAAY;IAChB;AACJ;;AAEA,YAAY;AACZ;IACI;QACI,YAAY;QACZ,cAAc;QACd,yBAAyB;IAC7B;AACJ;;AAEA;IACI;QACI,SAAS;QACT,mBAAmB;QACnB,mBAAmB;IACvB;AACJ;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kEAAkE;AACtE;;AAEA;IACI;QACI,oBAAoB;QACpB,qBAAqB;QACrB,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;;;;;GAKG;AACH,WAAW;;AAEX,eAAe;AACf;IACI,YAAY;IACZ,aAAa;IACb,4BAA4B;;IAE5B,eAAe;IACf,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,WAAW;AACf;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;;IAEhB,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;;AAEpC;;AAEA,cAAc;;AAEd,YAAY;AACZ;IACI,2BAA2B;AAC/B;;AAEA;IACI,uBAAuB;IACvB,2BAA2B;IAC3B,wCAAwC;AAC5C;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,qCAAqC;AACzC;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,gCAAgC;IAChC,iCAAiC;AACrC;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,QAAQ;IACR,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,cAAc;AAClB;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA,WAAW;;AAEX;IACI,uBAAuB;IACvB,SAAS;IACT,6BAA6B;AACjC;;AAEA,kDAAkD;AAClD,sCAAsC;;AAEtC;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,mDAAmD;IACnD,WAAW;IACX,YAAY;IACZ,SAAS;IACT,4BAA4B;IAC5B,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,QAAQ;IACR,2BAA2B;AAC/B;;AAEA;;IAEI,kBAAkB;IAClB,QAAQ;IACR,qBAAqB;IACrB,2BAA2B;IAC3B,wBAAwB;IACxB,UAAU;IACV,gBAAgB;IAChB,YAAY;IACZ,qBAAqB;IACrB,oBAAoB;IACpB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,OAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,qBAAqB;IACrB,UAAU;AACd;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,UAAU;AACd;;AAEA;;IAEI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,cAAc;IACd,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;;IAEI,YAAY;IACZ,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,UAAU;AACd;;AAEA;;IAEI,YAAY;AAChB;;AAEA,qCAAqC;AACrC;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA,mCAAmC;;AAEnC,QAAQ;AACR;IACI,YAAY;IACZ,yBAAyB;IACzB,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,oBAAoB;IACpB,wBAAwB;IACxB,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,SAAS;IACT,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,oBAAoB;IACpB,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,SAAS;IACT,kCAAkC;AACtC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;IAC1B,gCAAgC;IAChC,kBAAkB;IAClB,WAAW;IACX,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;IAC1B,gCAAgC;IAChC,kBAAkB;IAClB,WAAW;IACX,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,cAAc;IAEd,gKAAwJ;IAAxJ,wJAAwJ;IACxJ,iLAAgN;IAChN,0BAA0B;IAC1B,wDAAwD;AAC5D;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,cAAc;IAEd,gKAAwJ;IAAxJ,wJAAwJ;IACxJ,iLAAgN;IAChN,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA,aAAa;IACb;QACI,kCAAkC;IACtC;AACJ;;AAEA;IACI;QACI,kCAAkC;IACtC;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;;;;;;GAMG;;AAEH,sBAAsB;AACtB;IACI,aAAa;IACb,SAAS;;IAET,MAAM;IACN,OAAO;AACX;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,cAAc;;IAEd,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,yBAAyB;;IAEzB,kBAAkB;IAClB,QAAQ;IACR,UAAU;AACd;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,qBAAqB;IACrB,aAAa;IACb,cAAc;IACd,WAAW;;IAEX,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,UAAU;;IAEV,kBAAkB;IAClB,QAAQ;IACR,gBAAgB;IAChB,4CAA4C;IAC5C,2BAA2B;AAC/B;;AAEA;;IAEI,WAAW;IACX,cAAc;IACd,gBAAgB;IAChB,oBAAoB;IACpB,gBAAgB;;IAEhB,kBAAkB;IAClB,gBAAgB;IAChB,4CAA4C;AAChD;;AAEA;IACI,eAAe;;IAEf,MAAM;AACV;;AAEA;IACI,eAAe;;IAEf,aAAa;AACjB;;AAEA;IACI,QAAQ;IACR,UAAU;AACd;;AAEA;IACI,aAAa;;IAEb,qEAAqE;AACzE;;AAEA;IACI,aAAa;;IAEb,qEAAqE;AACzE;;AAEA;IACI;QACI,cAAc;IAClB;AACJ;;AAEA,oBAAoB;;AAEpB,cAAc;AACd;IACI,WAAW;IACX,kEAAkE;AACtE;;AAEA;IACI,WAAW;IACX,kEAAkE;AACtE;;AAEA,YAAY;;AAEZ;IACI,aAAa;IACb,oBAAoB;IACpB,WAAW;IACX,uBAAuB;IACvB,4BAA4B;IAC5B,oBAAoB;IACpB,iBAAiB;IACjB;8BAC0B;;IAE1B,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,oBAAoB;IACpB,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,UAAU;IACV,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,oBAAoB;IACpB,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,WAAW;IACf;;AAEJ;;AAEA;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;QACX,MAAM;QACN,oCAAoC;IACxC;;IAEA;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI,WAAW;IACX,aAAa;IACb,qBAAqB;IACrB,8BAA8B;IAC9B,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,2BAA2B;IAC3B,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,UAAU;AACd;;AAEA;IACI,WAAW;IACX,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,2BAA2B;IAC3B,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,UAAU;AACd;;AAEA;IACI,WAAW;IACX,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;IACpB,gBAAgB;AACpB;;;;;;;;AAQA;IACI,aAAa;IACb,8BAA8B;IAC9B,qBAAqB;IACrB,iBAAiB;IACjB,mCAAmC;IACnC,sBAAsB;IACtB,sBAAsB;IACtB,gBAAgB;IAChB,8BAA8B;;IAE9B,kBAAkB;AACtB;;AAEA;;GAEG;;;AAGH;IACI,SAAS;IACT,uBAAuB;AAC3B;;AAEA;IACI,wBAAwB;IACxB,aAAa;IACb,yBAAyB;IACzB,SAAS;AACb;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,YAAY;AAChB;;AAEA;;GAEG;AACH;;GAEG;AACH;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,+BAA+B;IAC/B,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,qBAAqB;IACrB,sBAAsB;IACtB,gDAAgD;IAChD,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI;QACI,SAAS;IACb;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,sBAAsB;QACtB,uBAAuB;QACvB,SAAS;IACb;;IAEA;QACI,WAAW;QACX,uBAAuB;QACvB,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,sBAAsB;QACtB,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,qBAAqB;IACzB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,iCAAiC;IACrC;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,sBAAsB;IAC1B;AACJ;;;AAGA,iBAAiB;AACjB;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,yBAAyB;QACzB,6BAA6B;QAC7B,2BAA2B;IAC/B;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,oBAAoB;QACpB,kBAAkB;IACtB;;IAEA;QACI;IACJ;;IAEA,uCAAuC;;IAEvC;QACI,iBAAiB;QACjB,UAAU;IACd;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,aAAa;QACb,SAAS;QACT,UAAU;IACd;;IAEA;QACI,UAAU;QACV,gBAAgB;QAChB,gBAAgB;QAChB,eAAe;QACf,iBAAiB;IACrB;;IAEA,uCAAuC;;IAEvC;QACI,QAAQ;QACR,WAAW;IACf;;IAEA,mEAAmE;;IAEnE,yEAAyE;AAC7E;;AAEA;;IAEI;;OAEG;IACH;QACI,aAAa;QACb,eAAe;QACf,WAAW;QACX;IACJ;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,cAAc;IAClB;AACJ;;AAEA,eAAe;;;AAGf,wEAAwE;;AAExE,oCAAoC;;AAEpC;IACI,UAAU;AACd;;AAEA;;;;;;;;;;GAUG;;AAEH;;GAEG;;AAEH;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oDAAoD;IACpD,qDAAqD;IACrD,oBAAoB;AACxB;;AAEA;IACI,uCAAuC;IACvC,kBAAkB;IAClB,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,oBAAoB;IACpB,cAAc;AAClB;;AAEA,8DAA8D;;AAE9D;IACI,SAAS;AACb;;AAEA;IACI,gBAAgB;AACpB;;AAEA,oDAAoD;;AAEpD;IACI,2BAA2B;IAC3B,yBAAyB;IACzB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,WAAW;IACX,cAAc;IACd,WAAW;IACX,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,0BAA0B;IAC1B,eAAe;IACf,qBAAqB;IACrB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,yBAAyB;IACzB,YAAY;IACZ,kCAAkC;AACtC;;AAEA,0DAA0D;;AAE1D;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB,eAAe;IACf,gCAAgC;IAChC,YAAY;IACZ,8BAA8B;IAC9B,WAAW;IACX,wBAAwB;AAC5B;;AAEA;IACI,aAAa;AACjB;;AAEA;;IAEI,cAAc;IACd,WAAW;IACX,UAAU;IACV,sBAAsB;IACtB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,sBAAsB;IACtB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,UAAU;IACV,uBAAuB;IACvB,sBAAsB;IACtB,cAAc;IACd,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,+BAA+B;IAC/B,YAAY;IACZ,cAAc;AAClB;;AAEA,8DAA8D;;AAE9D;IACI,mBAAmB;IACnB,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,YAAY;IACZ,mBAAmB;IACnB,oBAAoB;IACpB,mBAAmB;IACnB,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,wBAAwB;IACxB,UAAU;AACd;;AAEA;IACI,cAAc;AAClB;;;AAGA;;IAEI,WAAW;IACX,cAAc;IACd;qBACiB;AACrB;;AAEA;IACI,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,sBAAsB;IACtB,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA,cAAc;;AAEd;IACI;QACI,cAAc;QACd,eAAe;IACnB;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,SAAS;IACT,2BAA2B;IAC3B,WAAW;IACX,yBAAyB;IACzB,SAAS;IACT,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,sBAAsB;IACtB,mBAAmB;IACnB,iBAAiB;IACjB,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,4BAA4B;IAC5B,kCAAkC;IAClC,mBAAmB;AACvB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,oBAAoB;IACpB,qBAAqB;IACrB,oBAAoB;IACpB,gDAAgD;AACpD;;AAEA;IACI,SAAS;IACT,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,mBAAmB;IACnB,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kCAAkC;IAClC,mCAAmC;AACvC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,qBAAqB;IACrB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,eAAe;IACf,iBAAiB;IACjB,UAAU;AACd;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,gKAAgK;IAChK,wJAAwJ;IACxJ,iLAAiL;IACjL,wDAAwD;IACxD,0BAA0B;IAC1B,sDAAsD;AAC1D;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;;IAEI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,qBAAqB;IACrB,mCAAmC;IACnC,qCAAqC;AACzC","sourcesContent":[".pointer {\r\n    cursor: pointer;\r\n}\r\n\r\n.default {\r\n    cursor: default;\r\n}\r\n\r\n.main_btn_wrap {\r\n    margin-top: 100px;\r\n    text-align: center;\r\n    display: flex;\r\n    justify-content: center;\r\n}\r\n\r\n.main_btn_wrap>div {\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.main_btn_wrap>div button {\r\n    width: 100px;\r\n    height: 100px;\r\n}\r\n\r\n.ds_n {\r\n    display: none !important;\r\n}\r\n\r\n.fw-n {\r\n    font-weight: normal;\r\n}\r\n\r\n.content {\r\n    padding-top: 5rem;\r\n    /* margin-top: 3.5rem; */\r\n}\r\n\r\n@media (min-width: 1280px) {\r\n    .content .content-wrap {\r\n        /* padding-top: 5rem; */\r\n    }\r\n}\r\n\r\n@media (max-width: 1279px) {}\r\n\r\n@media (max-width: 768px) {\r\n    .content {\r\n        padding-top: .5rem;\r\n        margin: 3.5rem 0rem 0rem;\r\n    }\r\n\r\n    .contents_wrap {\r\n        height: auto;\r\n    }\r\n}\r\n\r\n/* left 시작 */\r\n@media (min-width: 1280px) {\r\n    .side-nav {\r\n        width: 12rem;\r\n        height: 100dvh;\r\n        padding: 5rem .75rem 4rem;\r\n    }\r\n}\r\n\r\n@media (min-width: 768px) {\r\n    .side-nav {\r\n        margin: 0;\r\n        padding-top: 4.5rem;\r\n        overflow-x: visible;\r\n    }\r\n}\r\n\r\n.side-nav>ul>li>.side-menu.side-menu--active .side-menu__icon {\r\n    color: #fff;\r\n}\r\n\r\n.side-nav>ul>li>.side-menu.side-menu--active .side-menu__title {\r\n    font-weight: bold;\r\n    color: #fff;\r\n}\r\n\r\n.side-nav>ul>li .depth-2 .side-menu--active .side-menu__title {\r\n    font-weight: bold;\r\n}\r\n\r\n.side-nav>ul>li>.side-menu.side-menu--active:before {\r\n    background-color: rgb(var(--color-primary) / var(--tw-bg-opacity));\r\n}\r\n\r\n@media (min-width: 1280px) {\r\n    .side-nav ul li .depth-2 {\r\n        margin-left: 1.25rem;\r\n        margin-bottom: .25rem;\r\n        padding: .125rem 0;\r\n    }\r\n}\r\n\r\n@media (max-width: 1280px) {\r\n    .side-nav {\r\n        width: 105px;\r\n    }\r\n}\r\n\r\n@media (max-width: 767px) {\r\n    .side-nav {\r\n        display: none;\r\n    }\r\n}\r\n\r\n/* @media (min-width: 1280px){\r\n    .side-nav {\r\n        height: 100vh;\r\n        \r\n    }\r\n} */\r\n/* left 끝 */\r\n\r\n/* loading 시작 */\r\n.pay_loading_wrap {\r\n    width: 100vw;\r\n    height: 100vh;\r\n    background: rgb(0 0 0 / 65%);\r\n\r\n    position: fixed;\r\n    top: 50%;\r\n    left: 50%;\r\n    transform: translate(-50%, -50%);\r\n    z-index: 60;\r\n}\r\n\r\n.pay_loading_wrap .pay_loading {\r\n    border-radius: 110px;\r\n    overflow: hidden;\r\n\r\n    position: absolute;\r\n    top: 50%;\r\n    left: 50%;\r\n    transform: translate(-50%, -50%);\r\n\r\n}\r\n\r\n/* loading 끝 */\r\n\r\n/* 공지사항 시작 */\r\n.notice .tabulator {\r\n    height: calc(100vh - 18rem);\r\n}\r\n\r\n.notice .tabulator .tabulator-tableHolder {\r\n    height: auto !important;\r\n    min-height: auto !important;\r\n    max-height: calc(100% - 8rem) !important;\r\n}\r\n\r\n.inner-wrap {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\n.content-container {\r\n    width: 100%;\r\n    /* max-width: 33.75rem; */\r\n    margin: auto;\r\n}\r\n\r\n.main-title-wrap {\r\n    /* padding-top: .75rem; */\r\n    border-bottom: .0625rem solid #d1d5d9;\r\n}\r\n\r\n.main-title-wrap .title {\r\n    display: inline-block;\r\n    position: relative;\r\n    padding: 0 1rem;\r\n    font-size: .875rem;\r\n    font-weight: bold;\r\n    line-height: 3.25rem;\r\n}\r\n\r\n.main-title-wrap .title:before {\r\n    content: \"\";\r\n    position: absolute;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: -.0625rem;\r\n    height: .1875rem;\r\n    background: #064e3b;\r\n    border-top-left-radius: .1875rem;\r\n    border-top-right-radius: .1875rem;\r\n}\r\n\r\n.main-title-wrap .btn-wrap {\r\n    position: absolute;\r\n    top: 50%;\r\n    right: 0;\r\n    transform: translateY(-50%);\r\n    padding-top: .75rem;\r\n}\r\n\r\n.main-title-wrap .btn-wrap button {\r\n    width: 2.25rem;\r\n    height: 2.25rem;\r\n}\r\n\r\n.main-title-wrap .btn-wrap button+button {\r\n    margin-left: .25rem;\r\n}\r\n\r\n.main-title-wrap .btn-wrap button svg {\r\n    width: auto;\r\n    height: 1.75rem;\r\n    margin: 0 auto;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n    .notice .tabulator {\r\n        height: auto;\r\n    }\r\n}\r\n\r\n/* 공지사항 끝 */\r\n\r\n.tabulator .tabulator-footer .tabulator-paginator {\r\n    justify-content: center;\r\n    margin: 0;\r\n    text-align: center !important;\r\n}\r\n\r\n/*-------------------- Modal --------------------*/\r\n/* .scroll_lock { overflow:hidden; } */\r\n\r\n.modal {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    transition: visibility 0s ease 0.2s, opacity .2s 0s;\r\n    width: auto;\r\n    height: auto;\r\n    margin: 0;\r\n    background: rgb(0 0 0 / 65%);\r\n    overflow-x: hidden;\r\n    overflow-y: auto;\r\n    visibility: visible;\r\n    opacity: 1;\r\n    z-index: 100000;\r\n}\r\n\r\n.modal.alert_modal .modal-dialog {\r\n    top: 50%;\r\n    transform: translateY(-50%);\r\n}\r\n\r\n.modal .modal-dialog,\r\n.modal#payment-modal .modal-dialog {\r\n    position: relative;\r\n    top: 50%;\r\n    /* transform: none; */\r\n    transform: translateY(-50%);\r\n    transition: top .3s ease;\r\n    width: 95%;\r\n    max-width: 40rem;\r\n    margin: auto;\r\n    padding: .5rem 1.5rem;\r\n    border-radius: .5rem;\r\n    background: #fff;\r\n    overflow: hidden;\r\n}\r\n\r\n.board_modal .modal-dialog {\r\n    top: 6%;\r\n    max-width: 42rem;\r\n}\r\n\r\n.modal .modal-dialog .modal-content {\r\n    margin: 0;\r\n    max-height: none;\r\n    box-shadow: none;\r\n}\r\n\r\n.modal .modal-dialog .modal-header {\r\n    position: relative;\r\n    width: auto;\r\n    /* padding: 1rem 0; */\r\n    padding: 0;\r\n}\r\n\r\n.modal .modal-dialog .modal-header h2 {\r\n    display: block;\r\n    font-weight: bold;\r\n}\r\n\r\n.modal .modal-dialog .modal-header button {\r\n    float: none;\r\n    padding: 0;\r\n}\r\n\r\n.modal .modal-dialog .modal-header button span,\r\n.modal .modal-dialog .modal-header button svg {\r\n    width: 1.625rem;\r\n    height: 1.625rem;\r\n}\r\n\r\n.modal .modal-dialog .modal-header .close_btn_sty svg {\r\n    transform: rotate(.37turn);\r\n}\r\n\r\n.modal .modal-dialog .modal-header svg {\r\n    transform: rotate(.37turn);\r\n}\r\n\r\n.modal .modal-dialog .modal-body {\r\n    overflow: auto;\r\n    margin: 0;\r\n    padding: 1.5rem 0;\r\n}\r\n\r\n.modal .modal-dialog .modal-body label {\r\n    margin-bottom: .375rem;\r\n    font-size: .8125rem;\r\n    font-weight: bold;\r\n}\r\n\r\n.modal .modal-dialog .modal-body input:read-only,\r\n.modal .modal-dialog .modal-body textarea:read-only {\r\n    border: none;\r\n    box-shadow: none;\r\n    color: #8292a3;\r\n}\r\n\r\n.modal .modal-dialog .modal-footer {\r\n    display: flex;\r\n    justify-content: center;\r\n    padding: 1rem 0 .5rem;\r\n    text-align: center;\r\n}\r\n\r\n.modal .modal-dialog .modal-footer button {\r\n    width: 50%;\r\n    max-width: 8rem;\r\n}\r\n\r\n.modal .modal-dialog .modal-footer button+button {\r\n    margin-left: .75rem;\r\n}\r\n\r\n.show_modal {\r\n    visibility: visible;\r\n    opacity: 1;\r\n}\r\n\r\n.show_modal .modal-dialog,\r\n.show_modal#payment-modal .modal-dialog {\r\n    /* top: 0; */\r\n}\r\n\r\n/* alert modal, confirm modal START */\r\n.modal .modal-footer .btn_ok {\r\n    color: #fff;\r\n    background-color: #064e3b;\r\n}\r\n\r\n/* alert modal, confirm modal END */\r\n\r\n/* top */\r\n.top-bar-boxed {\r\n    height: auto;\r\n    padding: 0.375rem 1.25rem;\r\n    /* padding: 0.375rem 1.375rem; */\r\n    background: #1a120b;\r\n}\r\n\r\n.top-bar-boxed:before {\r\n    content: none;\r\n}\r\n\r\n.top-bar-boxed:after {\r\n    content: none;\r\n}\r\n\r\n.top-bar-boxed .logo img {\r\n    width: auto;\r\n    max-width: none;\r\n    height: 2.5rem;\r\n}\r\n\r\n.dropdown-user-info {\r\n    z-index: 9999;\r\n    inset: 0 auto auto 0;\r\n    /* visibility: hidden; */\r\n    position: absolute;\r\n    /* opacity: 0; */\r\n    width: 224px;\r\n    margin: 0;\r\n    transform: translate(-192px, 53px);\r\n}\r\n\r\n.notification_list {\r\n    z-index: 9999;\r\n    inset: 0 auto auto 0;\r\n    visibility: hidden;\r\n    position: absolute;\r\n    opacity: 1;\r\n    width: 224px;\r\n    margin: 0;\r\n    transform: translate(-166px, 53px);\r\n}\r\n\r\n.notification_list .show>.dropdown-content {\r\n    margin-top: .25rem;\r\n}\r\n\r\n.notification_list .dropdown-content {\r\n    transition: margin-top .2s;\r\n    box-shadow: 0 3px 10px #00000017;\r\n    position: relative;\r\n    width: 100%;\r\n    border-radius: .375rem;\r\n    padding: .5rem;\r\n}\r\n\r\n.dropdown-user-info .show>.dropdown-content {\r\n    margin-top: .25rem;\r\n}\r\n\r\n.dropdown-user-info .dropdown-content {\r\n    transition: margin-top .2s;\r\n    box-shadow: 0 3px 10px #00000017;\r\n    position: relative;\r\n    width: 100%;\r\n    border-radius: .375rem;\r\n    padding: .5rem;\r\n}\r\n\r\n.dropdown-user-info .dropdown-content .dropdown-item {\r\n    display: flex;\r\n    align-items: center;\r\n    border-radius: .375rem;\r\n    padding: .5rem;\r\n    transition-property: color, background-color, border-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-text-decoration-color, -webkit-backdrop-filter;\r\n    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;\r\n    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-text-decoration-color, -webkit-backdrop-filter;\r\n    transition-duration: 300ms;\r\n    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\r\n}\r\n\r\n.notification_list .dropdown-content .dropdown-item {\r\n    display: flex;\r\n    align-items: center;\r\n    border-radius: .375rem;\r\n    padding: .5rem;\r\n    transition-property: color, background-color, border-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-text-decoration-color, -webkit-backdrop-filter;\r\n    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;\r\n    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-text-decoration-color, -webkit-backdrop-filter;\r\n    transition-duration: 300ms;\r\n}\r\n\r\n.dropdown-user-info.show {\r\n    visibility: visible;\r\n    opacity: 1;\r\n}\r\n\r\n@media(max-width:1278px) {\r\n    .top-bar-boxed {\r\n        display: none;\r\n    }\r\n\r\n    /* dropdown */\r\n    .dropdown-user-info {\r\n        transform: translate(-174px, 50px);\r\n    }\r\n}\r\n\r\n@media (max-width: 776px) {\r\n    .dropdown-user-info {\r\n        transform: translate(-171px, 50px);\r\n    }\r\n}\r\n\r\n@media(max-width:770px) {\r\n    .dropdown_user {\r\n        display: none;\r\n    }\r\n}\r\n\r\n/* @media(max-width:639px) {\r\n    .datepicker {\r\n        width: calc(100% - 58px - 0.25rem);\r\n        margin-bottom: 0.5rem;\r\n        width: 80%;\r\n    }\r\n} */\r\n\r\n/* mobile left START */\r\n.mobile-menu {\r\n    display: none;\r\n    margin: 0;\r\n\r\n    top: 0;\r\n    left: 0;\r\n}\r\n\r\n.mobile-menu .menu {\r\n    padding-left: .5rem;\r\n    padding-right: .5rem;\r\n    font-size: .9rem;\r\n}\r\n\r\n.mobile-menu .menu.on {\r\n    font-weight: bold;\r\n    color: #cce568;\r\n\r\n    position: relative;\r\n}\r\n\r\n.mobile-menu .menu.on::after {\r\n    content: \"\";\r\n    width: 5px;\r\n    height: 5px;\r\n    border-radius: 50%;\r\n    background-color: #cce568;\r\n\r\n    position: absolute;\r\n    top: 8px;\r\n    right: 4px;\r\n}\r\n\r\n.mobile-menu .mobile-menu-bar {\r\n    height: 57px;\r\n}\r\n\r\n.mobile-menu .mobile-menu-bar .mobile-menu-wrap {\r\n    margin-left: 2vw;\r\n    position: relative;\r\n    display: flex;\r\n}\r\n\r\n.mobile-menu .mobile-menu-bar .mobile-menu-toggler {\r\n    display: inline-block;\r\n    width: 2.5rem;\r\n    height: 2.5rem;\r\n    z-index: 10;\r\n\r\n    position: relative;\r\n}\r\n\r\n.mobile-menu .mobile-menu-bar .mobile-menu-toggler svg {\r\n    width: 0.875rem;\r\n    height: 0.125rem;\r\n    background: #acd560;\r\n    overflow: hidden;\r\n    opacity: 1;\r\n\r\n    position: absolute;\r\n    top: 50%;\r\n    right: 0.5625rem;\r\n    transition: .4s cubic-bezier(.5, .1, 0, 1.2);\r\n    transform: translateY(-50%);\r\n}\r\n\r\n.mobile-menu-toggler:after,\r\n.mobile-menu-toggler:before {\r\n    content: \"\";\r\n    display: block;\r\n    height: 0.125rem;\r\n    margin-top: 0.625rem;\r\n    background: #fff;\r\n\r\n    position: absolute;\r\n    right: 0.5625rem;\r\n    transition: .4s cubic-bezier(.5, .1, 0, 1.2);\r\n}\r\n\r\n.mobile-menu .mobile-menu-bar .mobile-menu-toggler:before {\r\n    width: 1.125rem;\r\n\r\n    top: 0;\r\n}\r\n\r\n.mobile-menu .mobile-menu-bar .mobile-menu-toggler:after {\r\n    width: 1.375rem;\r\n\r\n    top: 1.125rem;\r\n}\r\n\r\n.mobile-menu .mobile-menu-bar .mobile-menu-toggler.mobile-menu--active svg {\r\n    width: 0;\r\n    opacity: 0;\r\n}\r\n\r\n.mobile-menu .mobile-menu-bar .mobile-menu-toggler.mobile-menu--active:before {\r\n    width: 1.5rem;\r\n\r\n    transform: translateX(0.0625rem) translateY(0.5625rem) rotate(-45deg);\r\n}\r\n\r\n.mobile-menu .mobile-menu-bar .mobile-menu-toggler.mobile-menu--active:after {\r\n    width: 1.5rem;\r\n\r\n    transform: translateX(0.0625rem) translateY(-0.5625rem) rotate(45deg);\r\n}\r\n\r\n@media (max-width: 1278px) {\r\n    .mobile-menu {\r\n        display: block;\r\n    }\r\n}\r\n\r\n/* mobile left END */\r\n\r\n/* 페이징 START */\r\n.tabulator .tabulator-footer .tabulator-paginator .tabulator-page.active {\r\n    color: #fff;\r\n    background-color: rgb(var(--color-primary) / var(--tw-bg-opacity));\r\n}\r\n\r\n.tabulator .tabulator-footer .tabulator-paginator .tabulator-page.active:hover {\r\n    color: #fff;\r\n    background-color: rgb(var(--color-primary) / var(--tw-bg-opacity));\r\n}\r\n\r\n/* 페이징 END */\r\n\r\n.tabulator_summary_wrap {\r\n    display: flex;\r\n    column-gap: 0.875rem;\r\n    width: 100%;\r\n    align-items: flex-start;\r\n    /* padding: 1rem 0 1.5rem; */\r\n    /* margin: 1rem 0; */\r\n    margin: 0 0 .5rem;\r\n    /* background: #f1f5f9;\r\n    border-radius: 0.375rem; */\r\n\r\n    position: relative;\r\n}\r\n\r\n.payment .tabulator_summary_wrap {\r\n    flex-wrap: wrap;\r\n}\r\n\r\n.tabulator_summary_wrap .input_wrap {\r\n    display: flex;\r\n    flex-basis: 13.75rem;\r\n    flex-grow: 0;\r\n    align-items: center;\r\n    column-gap: 1rem;\r\n    padding: 0.5rem 1rem;\r\n    border-radius: 0.375rem;\r\n    background: #f1f5f9;\r\n}\r\n\r\n.tabulator_summary_wrap .input_wrap label {\r\n    flex-shrink: 0;\r\n    font-size: .8125rem;\r\n}\r\n\r\n.tabulator_summary_wrap .input_wrap input {\r\n    width: 100%;\r\n    padding: 0;\r\n    font-size: 1rem;\r\n    font-weight: bold;\r\n    text-align: right;\r\n    border: none;\r\n    box-shadow: none;\r\n    background-color: transparent;\r\n}\r\n\r\n.tabulator_summary_wrap .btn_more {\r\n    margin-left: 0.25rem;\r\n    outline: none;\r\n}\r\n\r\n.tabulator_summary_wrap .btn_more svg {\r\n    width: 1.25rem;\r\n    height: 1.25rem;\r\n    /* margin: 0.125rem; */\r\n}\r\n\r\n.tabulator_summary_wrap .btn_more.short svg {\r\n    transform: rotate(180deg);\r\n}\r\n\r\n@media (max-width: 1500px) {\r\n    .payment .tabulator_summary_wrap {\r\n        flex-direction: column;\r\n    }\r\n\r\n    .tabulator_summary_wrap {\r\n        gap: 0.25rem;\r\n    }\r\n\r\n    .tabulator_summary_wrap .input_wrap {\r\n        flex-basis: unset;\r\n    }\r\n\r\n    .payment .tabulator_summary_wrap .input_wrap {\r\n        width: 100%;\r\n    }\r\n\r\n}\r\n\r\n@media (max-width: 768px) {\r\n    .tabulator_summary_wrap {\r\n        flex-direction: column;\r\n    }\r\n\r\n    .tabulator_summary_wrap .input_wrap {\r\n        width: 100%;\r\n        gap: 0;\r\n        /* justify-content: space-between; */\r\n    }\r\n\r\n    .tabulator_summary_wrap input {\r\n        text-align: right;\r\n    }\r\n}\r\n\r\n.tabulator_sorting_wrap {\r\n    width: 100%;\r\n    display: flex;\r\n    align-items: flex-end;\r\n    justify-content: space-between;\r\n    height: 36px;\r\n}\r\n\r\n.tabulator_sorting_wrap .excel_download {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    gap: .375rem .625rem;\r\n}\r\n\r\n.tabulator_sorting_wrap .excel_download button {\r\n    border: none;\r\n    background: #434242;\r\n    font-size: .8125rem;\r\n    color: #fff;\r\n}\r\n\r\n.tabulator_sorting_wrap .excel_download button:hover {\r\n    background: #434242;\r\n}\r\n\r\n.tabulator_sorting_wrap .excel_download button svg {\r\n    width: 1.0625rem;\r\n    height: 1.0625rem;\r\n    margin-right: .375rem;\r\n}\r\n\r\n.tabulator_sorting_wrap .excel_download .btn-warning {\r\n    background: #f59e0b;\r\n}\r\n\r\n.tabulator_sorting_wrap .excel_download .btn-warning:hover {\r\n    background: #f58c0b;\r\n}\r\n\r\n.tabulator_sorting_wrap .rows_per_page {\r\n    flex-shrink: 0;\r\n}\r\n\r\n.tabulator_sorting_wrap .rows_per_page select {\r\n    height: 2.25rem;\r\n    font-size: .8125rem;\r\n    cursor: pointer;\r\n}\r\n\r\n.tabulator_sorting_wrap .excel_download .tabulator_total_cnt_wrap {\r\n    justify-content: flex-start;\r\n    position: relative;\r\n    right: auto;\r\n    margin: 0;\r\n    padding: 0;\r\n}\r\n\r\n.tabulator_sorting_wrap .excel_download .tabulator_total_cnt_wrap input {\r\n    width: auto;\r\n    padding: 0;\r\n    border-radius: 0;\r\n    background: none;\r\n    line-height: 2.25rem;\r\n    text-align: left;\r\n}\r\n\r\n.tabulator_total_cnt_wrap {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    margin: .5rem 0;\r\n}\r\n\r\n.tabulator_total_cnt_wrap input {\r\n    width: 100%;\r\n    border-radius: .375rem;\r\n    border: none;\r\n    background: #dce6ef;\r\n    font-size: .875rem;\r\n    font-weight: bold;\r\n    text-align: center;\r\n}\r\n\r\n.tabulator_total_cnt_wrap input:focus {\r\n    box-shadow: none;\r\n    border: none;\r\n    outline: none;\r\n}\r\n\r\n.tabulator_sorting_wrap .excel_download .tabulator_total_cnt_wrap {\r\n    justify-content: flex-start;\r\n    position: relative;\r\n    right: auto;\r\n    margin: 0;\r\n    padding: 0;\r\n}\r\n\r\n.tabulator_sorting_wrap .excel_download .tabulator_total_cnt_wrap input {\r\n    width: auto;\r\n    padding: 0;\r\n    border-radius: 0;\r\n    background: none;\r\n    line-height: 2.25rem;\r\n    text-align: left;\r\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n.form_filter {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: flex-end;\r\n    flex-wrap: nowrap;\r\n    /* padding: 1rem 1.25rem 1.25rem; */\r\n    padding: 0.5rem 0.5rem;\r\n    border-radius: 0.75rem;\r\n    background: #fff;\r\n    border: 0.125rem solid #064e3b;\r\n\r\n    position: relative;\r\n}\r\n\r\n/* .form_filter.outer {\r\n    margin-top: 1.25rem;\r\n} */\r\n\r\n\r\n.form_filter {\r\n    gap: 4rem;\r\n    align-items: flex-start;\r\n}\r\n\r\n.form_filter .form_filter_inner {\r\n    width: calc(100% - 5rem);\r\n    display: flex;\r\n    /* align-items: center; */\r\n    gap: 1rem;\r\n}\r\n\r\n.form_filter label {\r\n    display: inline-block;\r\n    font-size: .8125rem;\r\n    font-weight: bold;\r\n    flex-basis: 10%;\r\n    line-height: 2.375rem;\r\n}\r\n\r\n.form_filter .form_filter_inner>div {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    width: 90%;\r\n    gap: 0.25rem;\r\n}\r\n\r\n.form_filter .form_filter_inner>div>div {\r\n    gap: 0.25rem;\r\n    flex-grow: 1;\r\n}\r\n\r\n.form_filter .form_filter_inner>div>div>button {\r\n    width: auto;\r\n    flex-grow: 1;\r\n}\r\n\r\n.form_filter .form_filter_inner>div input {\r\n    width: 50%;\r\n    flex-grow: 1;\r\n}\r\n\r\n/* .paylist .form_filter .form_filter_inner > div input {\r\n    margin-bottom: 0.25rem;\r\n} */\r\n/* .paylist .form_filter .form_filter_inner > div button {\r\n    margin-left: 0.25rem;\r\n} */\r\n.form_filter .searchPayBtn {\r\n    /* width: 5rem; */\r\n}\r\n\r\n.paylist .more_wrap {\r\n    position: absolute;\r\n    bottom: 0;\r\n    left: 50%;\r\n    transform: translate(-50%, 60%);\r\n    z-index: 70;\r\n}\r\n\r\n.paylist .btn_more1 {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    column-gap: 0.25rem;\r\n    padding: 0.25rem 1rem;\r\n    border-radius: 1.75rem;\r\n    box-shadow: 0 0.0625rem 0.25rem rgb(0 0 0 / 20%);\r\n    background: #fff;\r\n    color: #074f3c;\r\n}\r\n\r\n.paylist .btn_more1 span {\r\n    font-size: .75rem;\r\n    font-weight: 500;\r\n}\r\n\r\n.paylist .btn_more1 svg {\r\n    width: 1rem;\r\n    height: 1rem;\r\n    transform: rotate(180deg);\r\n}\r\n\r\n.paylist .btn_more1.short svg {\r\n    transform: rotate(0deg);\r\n}\r\n\r\n@media (max-width: 1348px) {\r\n    .payment .form_filter {\r\n        gap: 1rem;\r\n    }\r\n\r\n    .payment .datepicker {\r\n        margin-bottom: 0;\r\n    }\r\n}\r\n\r\n@media (max-width: 823px) {\r\n    .form_filter .form_filter_inner>div input {\r\n        width: 40%;\r\n    }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n    .form_filter {\r\n        flex-direction: column;\r\n        align-items: flex-start;\r\n        gap: 1rem;\r\n    }\r\n\r\n    .form_filter .form_filter_inner {\r\n        width: 100%;\r\n        align-items: flex-start;\r\n        gap: 0.25rem;\r\n    }\r\n\r\n    .form_filter .form_filter_inner>div {\r\n        width: 100%;\r\n        flex-direction: column;\r\n        row-gap: 0.25rem;\r\n    }\r\n\r\n    .form_filter label {\r\n        flex-basis: 30%;\r\n        line-height: 2.375rem;\r\n    }\r\n\r\n    .form_filter .form_filter_inner>div input {\r\n        width: 100%;\r\n    }\r\n\r\n    .form_filter .form_filter_inner input {\r\n        width: 100%;\r\n    }\r\n\r\n    .form_filter>.searchPayBtn {\r\n        width: 100%;\r\n    }\r\n\r\n    .form_filter .form_filter_inner>div button {\r\n        width: calc((100% - 0.25rem) / 3);\r\n    }\r\n}\r\n\r\n@media(max-width: 508px) {\r\n    .form_filter label {\r\n        flex-basis: 20%;\r\n    }\r\n\r\n    .form_filter .form_filter_inner>div>div>button {\r\n        padding: 0.5rem 0.2rem;\r\n    }\r\n}\r\n\r\n\r\n/* notice START */\r\n.notice .form_filter {\r\n    gap: 0.5rem;\r\n    align-items: center;\r\n}\r\n\r\n.notice .input_item {\r\n    max-width: 300px;\r\n    flex-grow: 1;\r\n}\r\n\r\n.notice .form_filter label {\r\n    display: block;\r\n    margin-bottom: 0.25rem;\r\n    font-weight: bold;\r\n}\r\n\r\n@media(min-width:640px) {\r\n    .tabulator_summary_wrap .tabulator_total_cnt_wrap {\r\n        width: 100%;\r\n    }\r\n}\r\n\r\n@media (min-width: 768px) {\r\n    .notice .form_filter {\r\n        padding: 1rem 0 0;\r\n        border-color: transparent;\r\n        background-color: transparent;\r\n        justify-content: flex-start;\r\n    }\r\n\r\n    .notice .form_filter label {\r\n        display: none;\r\n    }\r\n\r\n    .tabulator_total_cnt_wrap {\r\n        margin: .1875rem 0 0;\r\n        padding-left: 2rem;\r\n    }\r\n\r\n    .tabulator_total_cnt_wrap input {\r\n        font-size: .9375rem\r\n    }\r\n\r\n    .tabulator_total_cnt_wrap input:focus {}\r\n\r\n    .tabulator_summary_wrap .tabulator_total_cnt_wrap {\r\n        margin-top: .5rem;\r\n        padding: 0;\r\n    }\r\n}\r\n\r\n@media(min-width:1280px) {\r\n    .tabulator_total_cnt_wrap {\r\n        position: absolute;\r\n        right: 1.5rem;\r\n        margin: 0;\r\n        padding: 0;\r\n    }\r\n\r\n    .tabulator_total_cnt_wrap input {\r\n        padding: 0;\r\n        border-radius: 0;\r\n        background: none;\r\n        font-size: 1rem;\r\n        text-align: right;\r\n    }\r\n\r\n    .tabulator_total_cnt_wrap input:focus {}\r\n\r\n    .tabulator_summary_wrap .tabulator_total_cnt_wrap {\r\n        right: 0;\r\n        width: auto;\r\n    }\r\n\r\n    .tabulator_sorting_wrap .excel_download .tabulator_total_cnt_wrap {}\r\n\r\n    .tabulator_sorting_wrap .excel_download .tabulator_total_cnt_wrap input {}\r\n}\r\n\r\n@media (max-width: 768px) {\r\n\r\n    /* .notice .form_filter .input_item {\r\n        width: auto;\r\n    } */\r\n    .notice .input_item {\r\n        display: flex;\r\n        max-width: 100%;\r\n        width: 100%;\r\n        gap: 0.5rem\r\n    }\r\n\r\n    .notice .input_item label {\r\n        flex-shrink: 0;\r\n    }\r\n\r\n    .notice .form_filter button {\r\n        flex-shrink: 0;\r\n    }\r\n}\r\n\r\n/* notice END */\r\n\r\n\r\n/*------------------------ modal receipt style ------------------------*/\r\n\r\n.modal .modal-dialog .type-receipt {}\r\n\r\n.modal .modal-dialog .type-receipt .modal-header {\r\n    z-index: 2;\r\n}\r\n\r\n/* .modal .modal-dialog .type-receipt .modal-header::after,\r\n.modal .modal-dialog .type-receipt .modal-footer::after {\r\n    content: \"\";\r\n    position: absolute;\r\n    left: -.4375rem;\r\n    width: .875rem;\r\n    height: .875rem;\r\n    border-radius: 50%;\r\n    box-shadow: 1rem 0 #fff, 2.5rem 0 #fff, 4rem 0 #fff, 5.5rem 0 #fff, 7rem 0 #fff, 8.5rem 0 #fff, 10rem 0 #fff, 11.5rem 0 #fff, 13rem 0 #fff, 14.5rem 0 #fff, 16rem 0 #fff, 17.5rem 0 #fff, 19rem 0 #fff, 20.5rem 0 #fff, 22rem 0 #fff, 23.5rem 0 #fff, 25rem 0 #fff, 26.5rem 0 #fff, 28rem 0 #fff, 29.5rem 0 #fff;\r\n    background: transparent;\r\n} */\r\n\r\n/* .modal .modal-dialog .type-receipt .modal-header::after {\r\n    bottom: -.4375rem;\r\n} */\r\n\r\n.modal .modal-dialog .type-receipt .modal-body {\r\n    position: relative;\r\n    padding: 0;\r\n}\r\n\r\n.modal .modal-dialog .type-receipt .modal-body::before {\r\n    content: \"\";\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    /* border-left: .0625rem solid rgba(0, 0, 0, .08); */\r\n    /* border-right: .0625rem solid rgba(0, 0, 0, .08); */\r\n    pointer-events: none;\r\n}\r\n\r\n.modal .modal-dialog .type-receipt .box-sales {\r\n    /* max-height: calc(100vh - 17.5rem); */\r\n    padding: 2rem 1rem;\r\n    /* background: #eee; */\r\n    overflow-y: auto;\r\n}\r\n\r\n.modal .modal-dialog .type-receipt .box-sales #header h1 {\r\n    /* filter: brightness(.75) grayscale(1); */\r\n}\r\n\r\n.modal .modal-dialog .type-receipt .box-sales #header h2 {\r\n    font-size: 1.0625rem;\r\n    color: #424242;\r\n}\r\n\r\n.modal .modal-dialog .type-receipt .box-sales .list-info-box {}\r\n\r\n.modal .modal-dialog .type-receipt .box-sales .box-gap {\r\n    margin: 0;\r\n}\r\n\r\n.modal .modal-dialog .type-receipt .box-sales .box-gap+.box-gap {\r\n    margin-top: 1rem;\r\n}\r\n\r\n.modal .modal-dialog .type-receipt .box-sales .gap {}\r\n\r\n.modal .modal-dialog .type-receipt .box-sales .gap .tt {\r\n    /* margin-bottom: .25rem; */\r\n    /* background: #d7d7d7; */\r\n    position: relative;\r\n    z-index: 1;\r\n}\r\n\r\n.modal .modal-dialog .type-receipt .box-sales .gap .tt::after {\r\n    content: '';\r\n    display: block;\r\n    clear: both;\r\n    background: #696a6b;\r\n    height: 1px;\r\n    position: absolute;\r\n    bottom: 0;\r\n    left: 0;\r\n    right: 0;\r\n}\r\n\r\n.modal .modal-dialog .type-receipt .box-sales .gap .tt h3 {\r\n    color: #fff;\r\n    font-size: 14px;\r\n    background: #898a8c;\r\n    border-radius: 5px 5px 0 0;\r\n    padding: 0 15px;\r\n    display: inline-block;\r\n    height: 27px;\r\n    line-height: 27px;\r\n    position: relative;\r\n    z-index: 2;\r\n    font-weight: normal;\r\n}\r\n\r\n.modal .modal-dialog .type-receipt .box-sales .gap li {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    /* column-gap: .875rem; */\r\n    border: none;\r\n    border-bottom: .0625rem solid #ddd;\r\n}\r\n\r\n.modal .modal-dialog .type-receipt .box-sales .gap li+li {}\r\n\r\n.modal .modal-dialog .type-receipt .box-sales .gap li::after {\r\n    display: none;\r\n}\r\n\r\n.modal .modal-dialog .type-receipt .box-sales .gap li .inner {\r\n    float: initial;\r\n    display: inline-flex;\r\n    flex-wrap: wrap;\r\n    flex-basis: calc(50% - .4375rem);\r\n    flex-grow: 1;\r\n    justify-content: space-between;\r\n    width: auto;\r\n    /* padding: .375rem 0; */\r\n}\r\n\r\n.modal .modal-dialog .type-receipt .box-sales .gap li .inner::after {\r\n    display: none;\r\n}\r\n\r\n.modal .modal-dialog .type-receipt .box-sales .gap li .inner .left-text,\r\n.modal .modal-dialog .type-receipt .box-sales .gap li .inner .right-text {\r\n    float: initial;\r\n    width: auto;\r\n    padding: 0;\r\n    /* font-size: .7rem; */\r\n    font-size: 9.5px;\r\n    color: #424242;\r\n}\r\n\r\n.modal .modal-dialog .type-receipt .box-sales .gap li .inner .left-text {\r\n    width: 32%;\r\n    background: #f9f9f9;\r\n    /* padding: 5px 12px; */\r\n    padding: 5px 0 5px 5px;\r\n    /* font-size: .7rem; */\r\n    font-size: 9.5px;\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\n.modal .modal-dialog .type-receipt .box-sales .gap li .inner .right-text {\r\n    word-break: break-word;\r\n    width: 68%;\r\n    /* padding: 5px 12px; */\r\n    padding: 5px 0 5px 5px;\r\n    color: #646464;\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\n.modal .modal-dialog .type-receipt .box-sales .type-2 {\r\n    display: flex;\r\n    column-gap: 1.25rem;\r\n}\r\n\r\n.modal .modal-dialog .type-receipt .box-sales .type-2 .gap {\r\n    width: auto;\r\n    flex-basis: calc(50% - .625rem);\r\n    flex-grow: 1;\r\n    flex-shrink: 0;\r\n}\r\n\r\n.modal .modal-dialog .type-receipt .box-sales .list-info-box {}\r\n\r\n.modal .modal-dialog .type-receipt .box-sales .infoFooter {\r\n    margin: 1.25rem 0 0;\r\n    /* font-size: .6875rem; */\r\n    font-size: 10px;\r\n    line-height: 1.5;\r\n    color: #424242;\r\n}\r\n\r\n.modal .modal-dialog .type-receipt .box-sales .box-btn {\r\n    margin: 1.25rem 0 0;\r\n}\r\n\r\n.modal .modal-dialog .type-receipt .box-sales .box-btn button {\r\n    height: 2.375rem;\r\n    margin: 0 0 0 -.1875rem;\r\n    border: none;\r\n    background: #424242;\r\n    font-family: inherit;\r\n    font-size: .9375rem;\r\n    font-weight: bold;\r\n    line-height: 2.375rem;\r\n}\r\n\r\n.modal .modal-dialog .type-receipt .modal-footer {\r\n    /* position: relative; */\r\n    z-index: 1;\r\n}\r\n\r\n.modal .modal-dialog .type-receipt .modal-footer::after {\r\n    top: -.4375rem;\r\n}\r\n\r\n\r\n.list-info-box .gap ul li .left-text,\r\n.list-info-box .gap ul li .right-text {\r\n    float: left;\r\n    color: #2d2e2f;\r\n    /* font-size: 14px;\r\n    padding: 7px 0; */\r\n}\r\n\r\n.list-info-box .gap ul li .left-text {\r\n    width: 100px;\r\n    font-weight: bold;\r\n}\r\n\r\n.box-sales #header {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    margin-bottom: 1.25rem;\r\n    padding: 0;\r\n    border: none;\r\n}\r\n\r\n.box-sales #header h1 img {\r\n    height: 2rem;\r\n}\r\n\r\n.tabulator_summary_wrap .d_none {\r\n    display: none;\r\n}\r\n\r\n/* loading 끝 */\r\n\r\n@media (min-width: 1280px) {\r\n    .side-nav .side-menu .side-menu__icon svg {\r\n        width: 1.25rem;\r\n        height: 1.25rem;\r\n    }\r\n}\r\n\r\n.mobile-menu .scrollable {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: space-between;\r\n    top: 52px;\r\n    transform: translateX(100%);\r\n    width: 100%;\r\n    height: calc(100% - 52px);\r\n    margin: 0;\r\n    background: #f1f5f9;\r\n    overflow-y: auto;\r\n}\r\n\r\n.mobile-menu.mobile-menu--active .scrollable {\r\n    transform: translateX(0);\r\n}\r\n\r\n.mobile-menu.mobile-menu--active .scrollable {\r\n    margin-left: 0px;\r\n}\r\n\r\n.mobile-menu .menu_wrap {\r\n    padding: 2rem 1.25rem 1.5rem;\r\n}\r\n\r\n.mobile-menu .user_info_wrap {\r\n    margin-bottom: 1.75rem;\r\n}\r\n\r\n.mobile-menu .user_detail {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: .375rem;\r\n    margin-bottom: .5rem;\r\n}\r\n\r\n.mobile-menu .user_detail .user_authority {\r\n    background: #fc8f94;\r\n}\r\n\r\n.mobile-menu .user_detail .user_organization {\r\n    background: #9da2f4;\r\n}\r\n\r\n.mobile-menu .user_detail span {\r\n    display: inline-block;\r\n    padding: .0625rem .5rem 0;\r\n    border-radius: .125rem;\r\n    background: #a6bacb;\r\n    font-size: .75rem;\r\n    line-height: 1.3125rem;\r\n    letter-spacing: -.02rem;\r\n    color: #fff;\r\n}\r\n\r\n.mobile-menu .user_greeting {\r\n    display: flex;\r\n    align-items: flex-end;\r\n    flex-wrap: wrap;\r\n}\r\n\r\n.mobile-menu .user_greeting .user_name {\r\n    font-size: 1.375rem;\r\n    font-weight: bold;\r\n}\r\n\r\n.mobile-menu .user_greeting p {\r\n    font-size: 1.125rem;\r\n    line-height: 1.75rem;\r\n    letter-spacing: -.02rem;\r\n    color: #1e203b;\r\n}\r\n\r\n.mobile-menu .user_greeting p {\r\n    font-size: 1.125rem;\r\n    line-height: 1.75rem;\r\n    letter-spacing: -.02rem;\r\n    color: #1e203b;\r\n}\r\n\r\n.mobile-menu .separation_line {\r\n    height: .625rem;\r\n    margin: 1.5rem -1.25rem 1rem;\r\n    border-top: .0625rem solid #cdd4dd;\r\n    background: #dde4ed;\r\n}\r\n\r\n.mobile-menu ul {\r\n    padding: 0;\r\n}\r\n\r\n.mobile-menu ul li {\r\n    -webkit-tap-highlight-color: transparent;\r\n}\r\n\r\n.mobile-menu ul li {\r\n    cursor: pointer;\r\n    max-width: 1280px;\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n    /* width: 100%; */\r\n}\r\n\r\n.mobile-menu .menu {\r\n    height: 4rem;\r\n    padding: 0;\r\n    color: #1e293b;\r\n}\r\n\r\n.mobile-menu .menu {\r\n    height: 50px;\r\n    display: flex;\r\n    align-items: center;\r\n    padding-left: 1.5rem;\r\n    padding-right: 1.5rem;\r\n    --tw-text-opacity: 1;\r\n    color: rgb(255 255 255 / var(--tw-text-opacity));\r\n}\r\n\r\n.mobile-menu ul li ul {\r\n    margin: 0;\r\n    padding: 0 0 1rem 1.5rem;\r\n    background: none;\r\n}\r\n\r\n.mobile-menu ul li ul {\r\n    margin-top: 0.25rem;\r\n    margin-bottom: 0.25rem;\r\n    border-radius: 0.5rem;\r\n}\r\n\r\n.mobile-menu ul li ul li {\r\n    border: none;\r\n}\r\n\r\n.mobile-menu ul li {\r\n    -webkit-tap-highlight-color: transparent;\r\n}\r\n\r\n.mobile-menu ul li {\r\n    cursor: pointer;\r\n    max-width: 1280px;\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n    /* width: 100%; */\r\n}\r\n\r\n.mobile-menu ul li ul .menu {\r\n    height: 2.625rem;\r\n    padding: 0;\r\n}\r\n\r\n.mobile-menu .menu {\r\n    height: 4rem;\r\n    padding: 0;\r\n    color: #1e293b;\r\n}\r\n\r\n.mobile-menu .menu {\r\n    display: flex;\r\n    align-items: center;\r\n    --tw-text-opacity: 1;\r\n}\r\n\r\n.mobile-menu ul li ul .menu .menu__title {\r\n    position: relative;\r\n    font-size: .9375rem;\r\n    letter-spacing: -.02rem;\r\n}\r\n\r\n.mobile-menu .menu .menu__title {\r\n    display: flex;\r\n    align-items: center;\r\n    width: 100%;\r\n    margin-left: .75rem;\r\n    font-size: 1.0625rem;\r\n    font-weight: bold;\r\n}\r\n\r\n.mobile-menu .logout-btn {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    border-top: .0625rem solid #d7d9da;\r\n    background: rgba(255, 255, 255, .5);\r\n}\r\n\r\n.mobile-menu .logout-btn a {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    height: 2.75rem;\r\n    padding: 0 1rem;\r\n    color: #64748b;\r\n}\r\n\r\n.mobile-menu .logout-btn svg {\r\n    position: relative;\r\n    top: -.125rem;\r\n    margin-right: .375rem;\r\n    width: 1.125rem;\r\n    height: 1.125rem;\r\n}\r\n\r\n.mobile-menu ul li+li {\r\n    border-top: .0625rem solid #d7d9da;\r\n}\r\n\r\n.mobile-menu .header_gnb {\r\n    display: flex;\r\n    column-gap: 2vw;\r\n    margin-right: 1vw;\r\n    padding: 0;\r\n}\r\n\r\n.mobile-menu .header_gnb li {\r\n    border: none;\r\n}\r\n\r\n.mobile-menu .header_gnb li a {\r\n    display: block;\r\n    position: relative;\r\n    padding: 0 .5rem;\r\n    font-size: .9375rem;\r\n    font-weight: 500;\r\n    line-height: 2.5rem;\r\n    color: rgba(255, 255, 255, .7);\r\n}\r\n\r\n.mobile-menu .menu .menu__title .menu__sub-icon {\r\n    transform: none;\r\n    position: relative;\r\n    width: 1.625rem;\r\n    height: 1.625rem;\r\n}\r\n\r\n.mobile-menu .menu .menu__title .menu__sub-icon {\r\n    margin-left: auto;\r\n    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;\r\n    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;\r\n    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;\r\n    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\r\n    transition-duration: 100ms;\r\n    transition-timing-function: cubic-bezier(0.4, 0, 1, 1);\r\n}\r\n\r\n.mobile-menu .menu .menu__title .menu__sub-icon::before {\r\n    width: 1rem;\r\n    height: .125rem;\r\n}\r\n\r\n.mobile-menu .menu .menu__title .menu__sub-icon::after {\r\n    width: .125rem;\r\n    height: 1rem;\r\n}\r\n\r\n.mobile-menu .menu .menu__title .menu__sub-icon.rotate-180::after {\r\n    display: none;\r\n}\r\n\r\n.mobile-menu .menu .menu__title .menu__sub-icon::before,\r\n.mobile-menu .menu .menu__title .menu__sub-icon::after {\r\n    content: \"\";\r\n    position: absolute;\r\n    top: 50%;\r\n    left: 50%;\r\n    transform: translate(-50%, -50%);\r\n    background: #227862;\r\n}\r\n\r\n.mobile-menu ul li ul .menu .menu__title::before {\r\n    content: \"\";\r\n    position: relative;\r\n    top: -.25rem;\r\n    width: .5rem;\r\n    height: .5rem;\r\n    margin-right: .625rem;\r\n    border-left: .0625rem solid #a7a9aa;\r\n    border-bottom: .0625rem solid #a7a9aa;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
